import { useEffect, useState, useCallback } from "react";
import { api } from "./api";

let cached = null;
let cachedAt = 0;
const TTL = 60_000;
const listeners = new Set();

export function useSettings() {
  const [settings, setSettings] = useState(cached);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      cached = data || {};
      cachedAt = Date.now();
      setSettings(cached);
      listeners.forEach((fn) => fn(cached));
    } catch {}
  }, []);

  useEffect(() => {
    const onUpdate = (s) => setSettings(s);
    listeners.add(onUpdate);
    if (!cached || Date.now() - cachedAt > TTL) refresh();
    return () => listeners.delete(onUpdate);
  }, [refresh]);

  return { settings: settings || {}, refresh };
}
